import * as React from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useL2DTheme } from '@europrocurement/flexy-components/hooks';
import { computeComponentColors } from '../../../hooks/useThemeContrastColor';

export type RoleChipProps = {
    label: string;
    backgroundColor?: string;
    textColor?: string;
};

export const RoleChip: React.FunctionComponent<RoleChipProps> = function ({
    label,
    backgroundColor,
    textColor,
}: RoleChipProps) {
    const { palette } = useL2DTheme();

    const token = backgroundColor
        ? computeComponentColors(backgroundColor, palette.mode)
        : palette.icon?.primary;

    return (
        <Box
            data-testid="RoleChip-test-id"
            sx={{
                backgroundColor: token?.backgroundColor,
                borderRadius: '8px',
                paddingY: '6px',
                paddingX: '15px',
                gap: '2px',
                maxHeight: 'fit-content',
            }}
        >
            <Typography
                variant="l2dcaption"
                sx={{ color: textColor || token?.textColor }}
            >
                {label}
            </Typography>
        </Box>
    );
};
